import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { getCurrentUser, updatePeriodicInfo } from '@hobs/actions/users';
import './SpUpdateInfoForm.scss';
import { createLoadingSelector } from '@hobs/utils/loading';
import UpdateInfoForm from '@hobs/containers/UpdateInfoForm/UpdateInfoForm';
import Toast from '@hobs/components/Toast';
import { PARTY_TYPE } from '@hobs/utils/constants';

class SpUpdateInfoForm extends UpdateInfoForm {
  setInformation = async () => {
    const { getCurrentUser } = this.props;

    const userResponse = await getCurrentUser(PARTY_TYPE.Supplier.Id);

    if (userResponse && userResponse.success) {
      this.setState({ phone: userResponse.payload.phone });
    } else if (userResponse) {
      Toast.warning(userResponse.payload.message);
    }
  };
}

const isLoading = createLoadingSelector([
  'Users/GetCurrent',
  'Users/UpdatePeriodicInfo'
]);

const mapStateToProps = state => ({
  isLoading: isLoading(state)
});

const mapDispatchToProps = {
  getCurrentUser,
  updatePeriodicInfo
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(SpUpdateInfoForm))
);
